import { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import Navbar from "../components/Navbar";
import CreateItemModal from "../components/CreateItemModal";
import EditItemModal from "../components/EditItemModal";
import api from "../config/api";

export default function StorageItems() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  const itemsPerPage = 10;

  const handleDeleteItem = async (id) => {
    const confirmDelete = window.confirm("Are you sure you want to delete this item?");
    if (!confirmDelete) return;

    try {
      const token = localStorage.getItem("token");
      const response = await fetch(api(`/items/${id}`), {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to delete item");
      }

      alert("Item deleted successfully.");
      fetchItems(); // Refresh list
    } catch (err) {
      console.error("Delete error:", err);
      alert("Failed to delete item.");
    }
  };

  const fetchItems = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(api("/items"), {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await response.json();
      setItems(data);
    } catch (err) {
      console.error("Failed to fetch items:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchItems();
  }, []);

  const filteredItems = items.filter((item) =>
    item.code?.toLowerCase().includes(searchQuery.toLowerCase()) ||
    item.description?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const totalPages = Math.ceil(filteredItems.length / itemsPerPage);
  const paginatedItems = filteredItems.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <div className="layout-wrapper layout-content-navbar">
      <div className="layout-container">
        <Sidebar />
        <div className="layout-page">
          <Navbar />
          <div className="content-wrapper">
            <div className="container-xxl flex-grow-1 container-p-y">
              <h2 className="mb-4">Storage Items</h2>

              {loading ? (
                <div>Loading...</div>
              ) : (
                <div className="card">
                  <div className="px-3 pt-3" style={{ maxWidth: "300px" }}>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search by code or description"
                      value={searchQuery}
                      onChange={(e) => {
                        setSearchQuery(e.target.value);
                        setCurrentPage(1);
                      }}
                    />
                  </div>

                  <div className="table-responsive p-3">
                    <table className="table table-striped" style={{ tableLayout: "fixed", width: "100%" }}>
                      <thead>
                        <tr>
                          <th style={{ width: "15%" }}>Code</th>
                          <th style={{ width: "35%" }}>Description</th>
                          <th style={{ width: "10%" }}>Stock</th>
                          <th style={{ width: "25%" }}>Updated At</th>
                          <th style={{ width: "15%" }}>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {paginatedItems.map((item) => (
                          <tr key={item.id}>
                            <td className="text-truncate">{item.code || "-"}</td>
                            <td className="text-truncate">{item.description || "-"}</td>
                            <td>{item.stock}</td>
                            <td>{new Date(item.updated_at).toLocaleString()}</td>
                            <td>
                              <div className="d-flex gap-2">
                                <button
                                  className="btn btn-sm btn-icon text-primary"
                                  title="Edit"
                                  onClick={() => {
                                    setSelectedItem(item);
                                    setShowEditModal(true);
                                  }}
                                >
                                  <i className="bx bx-edit"></i>
                                </button>
                                <button
                                  className="btn btn-sm btn-icon text-danger"
                                  title="Delete"
                                  onClick={() => handleDeleteItem(item.id)}
                                >
                                  <i className="bx bx-trash"></i>
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    <div className="d-flex justify-content-between align-items-center mt-3">
                      <small>Page {currentPage} of {totalPages}</small>
                      <div>
                        <button
                          className="btn btn-sm btn-outline-secondary me-2"
                          disabled={currentPage === 1}
                          onClick={() => setCurrentPage((prev) => prev - 1)}
                        >
                          Previous
                        </button>
                        <button
                          className="btn btn-sm btn-outline-secondary"
                          disabled={currentPage === totalPages}
                          onClick={() => setCurrentPage((prev) => prev + 1)}
                        >
                          Next
                        </button>
                      </div>
                    </div>

                    <button className="fab" onClick={() => setShowCreateModal(true)}>
                      <span className="icon">+</span>
                      <span className="label">Add New Item</span>
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <EditItemModal
        show={showEditModal}
        onClose={() => setShowEditModal(false)}
        itemData={selectedItem}
        onSuccess={fetchItems}
      />

      <CreateItemModal
        show={showCreateModal}
        onClose={() => setShowCreateModal(false)}
        onSuccess={fetchItems}
      />
    </div>
  );
}
